/**
 * Enum chỉnh lý
 */
export default {
  NotReadjust: 0, // chưa chỉnh lý
  Readjust: 1, // đã chỉnh lý
};
